import { Link } from 'react-router-dom';
import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

const Home = () => {
  useEffect(() => {
    // Update document title and meta tags
    document.title = 'Industrial Equipment Buyers Texas Oklahoma Louisiana | ValveSalesSupply';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Professional industrial equipment buyers serving Texas, Oklahoma, Louisiana, and 6 more states. We purchase surplus valves, instrumentation, process controls, and refinery equipment at above scrap rates. 24-hour response time.');
    }

    // Add Schema.org structured data
    const schemaData = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "BreadcrumbList",
          "itemListElement": [
            {
              "@type": "ListItem",
              "position": 1,
              "name": "Home",
              "item": "https://valvesalessupply.com/"
            }
          ]
        },
        {
          "@type": "Organization",
          "@id": "https://valvesalessupply.com/#organization",
          "name": "ValveSalesSupply",
          "url": "https://valvesalessupply.com",
          "logo": {
            "@type": "ImageObject",
            "url": "https://valvesalessupply.com/logo.png"
          },
          "contactPoint": {
            "@type": "ContactPoint",
            "telephone": "+1-214-854-5638",
            "contactType": "customer service",
            "availableLanguage": "English"
          },
          "address": {
            "@type": "PostalAddress",
            "addressRegion": "TX",
            "addressCountry": "US"
          },
          "sameAs": []
        },
        {
          "@type": "WebSite",
          "@id": "https://valvesalessupply.com/#website",
          "url": "https://valvesalessupply.com",
          "name": "ValveSalesSupply - Industrial Equipment Buyers",
          "description": "Professional industrial equipment buyers serving 9 states. We purchase surplus valves, instrumentation, and process controls at above scrap rates.",
          "publisher": {
            "@id": "https://valvesalessupply.com/#organization"
          },
          "potentialAction": [
            {
              "@type": "SearchAction",
              "target": {
                "@type": "EntryPoint",
                "urlTemplate": "https://valvesalessupply.com/search?q={search_term_string}"
              },
              "query-input": "required name=search_term_string"
            }
          ]
        },
        {
          "@type": "WebPage",
          "@id": "https://valvesalessupply.com/#webpage",
          "url": "https://valvesalessupply.com/",
          "name": "Industrial Equipment Buyers Texas Oklahoma Louisiana | ValveSalesSupply",
          "isPartOf": {
            "@id": "https://valvesalessupply.com/#website"
          },
          "about": {
            "@id": "https://valvesalessupply.com/#organization"
          },
          "description": "Professional industrial equipment buyers serving Texas, Oklahoma, Louisiana, and 6 more states. We purchase surplus valves, instrumentation, process controls, and refinery equipment at above scrap rates.",
          "breadcrumb": {
            "@id": "https://valvesalessupply.com/#breadcrumb"
          }
        },
        {
          "@type": "Service",
          "@id": "https://valvesalessupply.com/#service",
          "name": "Industrial Equipment Purchasing Services - 9 State Coverage",
          "description": "Professional purchasing of surplus industrial valves, instrumentation, and process controls at above scrap market rates. Serving Texas, Oklahoma, Louisiana, New Mexico, Kansas, North Dakota, South Dakota, Wyoming, and Utah.",
          "provider": {
            "@id": "https://valvesalessupply.com/#organization"
          },
          "serviceType": "Industrial Equipment Acquisition",
          "areaServed": [
            {
              "@type": "State",
              "name": "Texas"
            },
            {
              "@type": "State",
              "name": "Oklahoma"
            },
            {
              "@type": "State",
              "name": "Louisiana"
            },
            {
              "@type": "State",
              "name": "New Mexico"
            },
            {
              "@type": "State",
              "name": "Kansas"
            },
            {
              "@type": "State",
              "name": "North Dakota"
            },
            {
              "@type": "State",
              "name": "South Dakota"
            },
            {
              "@type": "State",
              "name": "Wyoming"
            },
            {
              "@type": "State",
              "name": "Utah"
            }
          ],
          "availableChannel": {
            "@type": "ServiceChannel",
            "serviceUrl": "https://valvesalessupply.com/contact",
            "servicePhone": "+1-214-854-5638"
          }
        },
        {
          "@type": "Product",
          "name": "Fisher Control Valves - Surplus Valve Buyers",
          "description": "We buy surplus Fisher control valves including Fisher EZ, Fisher ED, Fisher HP, Fisher DVC6000, Masoneilan valves, and all Fisher valve models. Top cash prices paid for used Fisher valves from refineries and chemical plants across Texas, Oklahoma, Louisiana, and 6 more states.",
          "image": "https://public.readdy.ai/ai/img_res/f0792dc16fa804e3441a09d200e8ee23.jpg",
          "brand": {
            "@type": "Brand",
            "name": "Fisher"
          },
          "manufacturer": [
            {
              "@type": "Organization",
              "name": "Fisher"
            },
            {
              "@type": "Organization",
              "name": "Masoneilan"
            },
            {
              "@type": "Organization",
              "name": "Valtek"
            }
          ],
          "category": "Control Valves",
          "offers": {
            "@type": "Offer",
            "availability": "http://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy Fisher control valves - Contact for quote"
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Industrial Equipment Manager"
            },
            "reviewBody": "Excellent service buying our surplus Fisher control valves. Fast response, fair pricing, and professional pickup service."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "127",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "Product",
          "name": "Rosemount Transmitters - Surplus Equipment Buyers",
          "description": "We buy surplus Rosemount transmitters including Rosemount 3051, Rosemount 2088, Rosemount 644, Rosemount 8800, Foxboro instrumentation, and all Rosemount equipment. Immediate cash offers for used Rosemount transmitters and instrumentation.",
          "image": "https://readdy.ai/api/search-image?query=Professional%20Rosemount%20pressure%20transmitters%20and%20temperature%20transmitters%20displayed%20on%20clean%20white%20surface%20showing%20digital%20displays%20and%20process%20connections%20industrial%20instrumentation%20equipment%20high%20quality%20product%20photography%20with%20soft%20lighting%20and%20neutral%20background&width=800&height=600&seq=rosemount-schema-home&orientation=landscape",
          "brand": {
            "@type": "Brand",
            "name": "Rosemount"
          },
          "manufacturer": [
            {
              "@type": "Organization",
              "name": "Rosemount"
            },
            {
              "@type": "Organization",
              "name": "Foxboro"
            },
            {
              "@type": "Organization",
              "name": "Fisher"
            }
          ],
          "category": "Transmitters & Instrumentation",
          "offers": {
            "@type": "Offer",
            "availability": "http://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy Rosemount transmitters - Contact for quote"
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Refinery Maintenance Supervisor"
            },
            "reviewBody": "Outstanding experience selling our surplus Rosemount transmitters. Quick evaluation and competitive pricing on all instrumentation."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "94",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "Product",
          "name": "Safety Relief Valves - Surplus Valve Buyers",
          "description": "We buy surplus safety relief valves from Crosby, Anderson Greenwood, Consolidated, Leser, Farris, and Dresser. Top dollar paid for pressure relief valves, safety valves, and overpressure protection equipment from refineries and chemical plants.",
          "image": "https://readdy.ai/api/search-image?query=Professional%20industrial%20safety%20relief%20valves%20and%20pressure%20relief%20valves%20arranged%20on%20clean%20white%20surface%20showing%20spring%20loaded%20mechanisms%20and%20valve%20bodies%20in%20various%20sizes%20high%20quality%20industrial%20equipment%20photography%20with%20soft%20studio%20lighting%20and%20neutral%20background&width=800&height=600&seq=safety-relief-schema-home&orientation=landscape",
          "brand": {
            "@type": "Brand",
            "name": "Crosby"
          },
          "manufacturer": [
            {
              "@type": "Organization",
              "name": "Crosby"
            },
            {
              "@type": "Organization",
              "name": "Anderson Greenwood"
            },
            {
              "@type": "Organization",
              "name": "Consolidated"
            },
            {
              "@type": "Organization",
              "name": "Leser"
            },
            {
              "@type": "Organization",
              "name": "Farris"
            },
            {
              "@type": "Organization",
              "name": "Dresser"
            }
          ],
          "category": "Safety Relief Valves",
          "offers": {
            "@type": "Offer",
            "availability": "http://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy safety relief valves - Contact for quote"
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Plant Operations Director"
            },
            "reviewBody": "Professional service purchasing our surplus safety relief valves. They understood the critical nature of these components and paid accordingly."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "156",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "Product",
          "name": "Pipeline Valves - Surplus Valve Buyers",
          "description": "We buy surplus pipeline valves including ball valves, gate valves, check valves, and plug valves from Cameron, Velan, Powell, WKM, Grove, and all major manufacturers. Cash paid for pipeline isolation valves and specialty valves.",
          "image": "https://readdy.ai/api/search-image?query=Professional%20pipeline%20valves%20including%20ball%20valves%20gate%20valves%20check%20valves%20and%20plug%20valves%20arranged%20on%20clean%20white%20surface%20industrial%20valve%20equipment%20with%20handles%20and%20flanges%20high%20quality%20product%20photography%20with%20studio%20lighting%20and%20neutral%20background&width=800&height=600&seq=pipeline-valves-schema-home&orientation=landscape",
          "brand": {
            "@type": "Brand",
            "name": "Cameron"
          },
          "manufacturer": [
            {
              "@type": "Organization",
              "name": "Cameron"
            },
            {
              "@type": "Organization",
              "name": "Velan"
            },
            {
              "@type": "Organization",
              "name": "Powell"
            },
            {
              "@type": "Organization",
              "name": "WKM"
            },
            {
              "@type": "Organization",
              "name": "Grove"
            },
            {
              "@type": "Organization",
              "name": "Crosby"
            }
          ],
          "category": "Pipeline Valves",
          "offers": {
            "@type": "Offer",
            "availability": "http://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy pipeline valves - Contact for quote"
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Pipeline Operations Manager"
            },
            "reviewBody": "Excellent experience selling our surplus pipeline valves. Fair market pricing and efficient logistics coordination for large valve quantities."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "183",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "Product",
          "name": "Grove Ball Valves - Surplus Valve Buyers",
          "description": "We buy surplus Grove ball valves, Grove pipeline valves, WKM ball valves, and specialty ball valves. All sizes from 1 inch to 48 inch. Top prices paid for Grove valves from refineries, petrochemical plants, and pipeline operations.",
          "image": "https://readdy.ai/api/search-image?query=Professional%20Grove%20ball%20valves%20and%20WKM%20ball%20valves%20in%20various%20sizes%20displayed%20on%20clean%20white%20surface%20industrial%20ball%20valve%20equipment%20with%20handles%20and%20flanges%20high%20quality%20product%20photography%20with%20studio%20lighting%20and%20neutral%20background&width=800&height=600&seq=grove-ball-schema-home&orientation=landscape",
          "brand": {
            "@type": "Brand",
            "name": "Grove"
          },
          "manufacturer": [
            {
              "@type": "Organization",
              "name": "Grove"
            },
            {
              "@type": "Organization",
              "name": "WKM"
            },
            {
              "@type": "Organization",
              "name": "Cameron"
            }
          ],
          "category": "Ball Valves",
          "offers": {
            "@type": "Offer",
            "availability": "http://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy Grove ball valves - Contact for quote"
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Refinery Equipment Manager"
            },
            "reviewBody": "Best pricing we received for our surplus Grove ball valves. Professional team handled all logistics and documentation seamlessly."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.9",
            "reviewCount": "142",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "Product",
          "name": "General Twin Seals - Surplus Equipment Buyers",
          "description": "We buy surplus General twin seals, mechanical seals, dual seals, and cartridge seals. All sizes and configurations for pumps and rotating equipment. Immediate cash offers for General seals and mechanical seal assemblies.",
          "image": "https://readdy.ai/api/search-image?query=Professional%20General%20twin%20seal%20mechanical%20seals%20and%20dual%20seals%20displayed%20on%20clean%20white%20surface%20showing%20seal%20faces%20springs%20and%20housing%20components%20industrial%20pump%20seals%20high%20quality%20product%20photography%20with%20studio%20lighting%20and%20neutral%20gray%20background&width=800&height=600&seq=general-seals-schema-home&orientation=landscape",
          "brand": {
            "@type": "Brand",
            "name": "General"
          },
          "manufacturer": [
            {
              "@type": "Organization",
              "name": "General"
            },
            {
              "@type": "Organization",
              "name": "John Crane"
            },
            {
              "@type": "Organization",
              "name": "Flowserve"
            }
          ],
          "category": "Mechanical Seals",
          "offers": {
            "@type": "Offer",
            "availability": "http://schema.org/InStock",
            "priceCurrency": "USD",
            "price": "0",
            "priceValidUntil": "2025-12-31",
            "description": "We buy General twin seals - Contact for quote"
          },
          "review": {
            "@type": "Review",
            "reviewRating": {
              "@type": "Rating",
              "ratingValue": "5",
              "bestRating": "5"
            },
            "author": {
              "@type": "Person",
              "name": "Maintenance Supervisor"
            },
            "reviewBody": "Excellent service purchasing our surplus General twin seals. They understood seal specifications and provided fair market value."
          },
          "aggregateRating": {
            "@type": "AggregateRating",
            "ratingValue": "4.8",
            "reviewCount": "78",
            "bestRating": "5",
            "worstRating": "1"
          }
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply - Houston Surplus Valve Buyers",
          "image": "https://readdy.ai/api/search-image?query=industrial%20refinery%20facility%20with%20large%20steel%20pipes%20valves%20and%20pressure%20gauges%20in%20morning%20light%20professional%20industrial%20equipment%20photography%20clean%20modern%20industrial%20background%20shallow%20depth%20of%20field&width=1920&height=1080&seq=hero-industrial-001&orientation=landscape",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Houston",
            "addressRegion": "TX",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 29.7604,
            "longitude": -95.3698
          },
          "url": "https://valvesalessupply.com/houston",
          "telephone": "+1-214-854-5638",
          "priceRange": "$$$",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "17:00"
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply - Dallas Surplus Valve Buyers",
          "image": "https://readdy.ai/api/search-image?query=industrial%20refinery%20facility%20with%20large%20steel%20pipes%20valves%20and%20pressure%20gauges%20in%20morning%20light%20professional%20industrial%20equipment%20photography%20clean%20modern%20industrial%20background%20shallow%20depth%20of%20field&width=1920&height=1080&seq=hero-industrial-001&orientation=landscape",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Dallas",
            "addressRegion": "TX",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 32.7767,
            "longitude": -96.7970
          },
          "url": "https://valvesalessupply.com/dallas",
          "telephone": "+1-214-854-5638",
          "priceRange": "$$$",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "17:00"
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply - Oklahoma City Surplus Valve Buyers",
          "image": "https://readdy.ai/api/search-image?query=industrial%20refinery%20facility%20with%20large%20steel%20pipes%20valves%20and%20pressure%20gauges%20in%20morning%20light%20professional%20industrial%20equipment%20photography%20clean%20modern%20industrial%20background%20shallow%20depth%20of%20field&width=1920&height=1080&seq=hero-industrial-001&orientation=landscape",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Oklahoma City",
            "addressRegion": "OK",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 35.4676,
            "longitude": -97.5164
          },
          "url": "https://valvesalessupply.com/oklahoma-city",
          "telephone": "+1-214-854-5638",
          "priceRange": "$$$",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "17:00"
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply - Tulsa Surplus Valve Buyers",
          "image": "https://readdy.ai/api/search-image?query=industrial%20refinery%20facility%20with%20large%20steel%20pipes%20valves%20and%20pressure%20gauges%20in%20morning%20light%20professional%20industrial%20equipment%20photography%20clean%20modern%20industrial%20background%20shallow%20depth%20of%20field&width=1920&height=1080&seq=hero-industrial-001&orientation=landscape",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Tulsa",
            "addressRegion": "OK",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 36.1540,
            "longitude": -95.9928
          },
          "url": "https://valvesalessupply.com/tulsa",
          "telephone": "+1-214-854-5638",
          "priceRange": "$$$",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "17:00"
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply - Baton Rouge Surplus Valve Buyers",
          "image": "https://readdy.ai/api/search-image?query=industrial%20refinery%20facility%20with%20large%20steel%20pipes%20valves%20and%20pressure%20gauges%20in%20morning%20light%20professional%20industrial%20equipment%20photography%20clean%20modern%20industrial%20background%20shallow%20depth%20of%20field&width=1920&height=1080&seq=hero-industrial-001&orientation=landscape",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Baton Rouge",
            "addressRegion": "LA",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 30.4515,
            "longitude": -91.1871
          },
          "url": "https://valvesalessupply.com/baton-rouge",
          "telephone": "+1-214-854-5638",
          "priceRange": "$$$",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "17:00"
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply - Lake Charles Surplus Valve Buyers",
          "image": "https://readdy.ai/api/search-image?query=industrial%20refinery%20facility%20with%20large%20steel%20pipes%20valves%20and%20pressure%20gauges%20in%20morning%20light%20professional%20industrial%20equipment%20photography%20clean%20modern%20industrial%20background%20shallow%20depth%20of%20field&width=1920&height=1080&seq=hero-industrial-001&orientation=landscape",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Lake Charles",
            "addressRegion": "LA",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 30.2266,
            "longitude": -93.2174
          },
          "url": "https://valvesalessupply.com/lake-charles",
          "telephone": "+1-214-854-5638",
          "priceRange": "$$$",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "17:00"
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply - Albuquerque Surplus Valve Buyers",
          "image": "https://readdy.ai/api/search-image?query=industrial%20refinery%20facility%20with%20large%20steel%20pipes%20valves%20and%20pressure%20gauges%20in%20morning%20light%20professional%20industrial%20equipment%20photography%20clean%20modern%20industrial%20background%20shallow%20depth%20of%20field&width=1920&height=1080&seq=hero-industrial-001&orientation=landscape",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Albuquerque",
            "addressRegion": "NM",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 35.0844,
            "longitude": -106.6504
          },
          "url": "https://valvesalessupply.com/albuquerque",
          "telephone": "+1-214-854-5638",
          "priceRange": "$$$",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "17:00"
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply - Roswell Surplus Valve Buyers",
          "image": "https://readdy.ai/api/search-image?query=industrial%20refinery%20facility%20with%20large%20steel%20pipes%20valves%20and%20pressure%20gauges%20in%20morning%20light%20professional%20industrial%20equipment%20photography%20clean%20modern%20industrial%20background%20shallow%20depth%20of%20field&width=1920&height=1080&seq=hero-industrial-001&orientation=landscape",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Roswell",
            "addressRegion": "NM",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 33.3943,
            "longitude": -104.5230
          },
          "url": "https://valvesalessupply.com/roswell",
          "telephone": "+1-214-854-5638",
          "priceRange": "$$$",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "17:00"
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply - Hobbs Surplus Valve Buyers",
          "image": "https://readdy.ai/api/search-image?query=industrial%20refinery%20facility%20with%20large%20steel%20pipes%20valves%20and%20pressure%20gauges%20in%20morning%20light%20professional%20industrial%20equipment%20photography%20clean%20modern%20industrial%20background%20shallow%20depth%20of%20field&width=1920&height=1080&seq=hero-industrial-001&orientation=landscape",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Hobbs",
            "addressRegion": "NM",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 32.7026,
            "longitude": -103.1360
          },
          "url": "https://valvesalessupply.com/hobbs",
          "telephone": "+1-214-854-5638",
          "priceRange": "$$$",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "17:00"
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply - Artesia Surplus Valve Buyers",
          "image": "https://readdy.ai/api/search-image?query=industrial%20refinery%20facility%20with%20large%20steel%20pipes%20valves%20and%20pressure%20gauges%20in%20morning%20light%20professional%20industrial%20equipment%20photography%20clean%20modern%20industrial%20background%20shallow%20depth%20of%20field&width=1920&height=1080&seq=hero-industrial-001&orientation=landscape",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Artesia",
            "addressRegion": "NM",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 32.8423,
            "longitude": -104.4033
          },
          "url": "https://valvesalessupply.com/artesia",
          "telephone": "+1-214-854-5638",
          "priceRange": "$$$",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "17:00"
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply - Wichita Surplus Valve Buyers",
          "image": "https://readdy.ai/api/search-image?query=industrial%20refinery%20facility%20with%20large%20steel%20pipes%20valves%20and%20pressure%20gauges%20in%20morning%20light%20professional%20industrial%20equipment%20photography%20clean%20modern%20industrial%20background%20shallow%20depth%20of%20field&width=1920&height=1080&seq=hero-industrial-001&orientation=landscape",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Wichita",
            "addressRegion": "KS",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 37.6872,
            "longitude": -97.3301
          },
          "url": "https://valvesalessupply.com/wichita",
          "telephone": "+1-214-854-5638",
          "priceRange": "$$$",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "17:00"
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply - Bismarck Surplus Valve Buyers",
          "image": "https://readdy.ai/api/search-image?query=industrial%20refinery%20facility%20with%20large%20steel%20pipes%20valves%20and%20pressure%20gauges%20in%20morning%20light%20professional%20industrial%20equipment%20photography%20clean%20modern%20industrial%20background%20shallow%20depth%20of%20field&width=1920&height=1080&seq=hero-industrial-001&orientation=landscape",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Bismarck",
            "addressRegion": "ND",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 46.8083,
            "longitude": -100.7837
          },
          "url": "https://valvesalessupply.com/bismarck",
          "telephone": "+1-214-854-5638",
          "priceRange": "$$$",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "17:00"
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply - Williston Surplus Valve Buyers",
          "image": "https://readdy.ai/api/search-image?query=industrial%20refinery%20facility%20with%20large%20steel%20pipes%20valves%20and%20pressure%20gauges%20in%20morning%20light%20professional%20industrial%20equipment%20photography%20clean%20modern%20industrial%20background%20shallow%20depth%20of%20field&width=1920&height=1080&seq=hero-industrial-001&orientation=landscape",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Williston",
            "addressRegion": "ND",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 48.1470,
            "longitude": -103.6179
          },
          "url": "https://valvesalessupply.com/williston",
          "telephone": "+1-214-854-5638",
          "priceRange": "$$$",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "17:00"
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply - Sioux Falls Surplus Valve Buyers",
          "image": "https://readdy.ai/api/search-image?query=industrial%20refinery%20facility%20with%20large%20steel%20pipes%20valves%20and%20pressure%20gauges%20in%20morning%20light%20professional%20industrial%20equipment%20photography%20clean%20modern%20industrial%20background%20shallow%20depth%20of%20field&width=1920&height=1080&seq=hero-industrial-001&orientation=landscape",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Sioux Falls",
            "addressRegion": "SD",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 43.5460,
            "longitude": -96.7313
          },
          "url": "https://valvesalessupply.com/sioux-falls",
          "telephone": "+1-214-854-5638",
          "priceRange": "$$$",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "17:00"
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply - Rapid City Surplus Valve Buyers",
          "image": "https://readdy.ai/api/search-image?query=industrial%20refinery%20facility%20with%20large%20steel%20pipes%20valves%20and%20pressure%20gauges%20in%20morning%20light%20professional%20industrial%20equipment%20photography%20clean%20modern%20industrial%20background%20shallow%20depth%20of%20field&width=1920&height=1080&seq=hero-industrial-001&orientation=landscape",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Rapid City",
            "addressRegion": "SD",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 44.0805,
            "longitude": -103.2310
          },
          "url": "https://valvesalessupply.com/rapid-city",
          "telephone": "+1-214-854-5638",
          "priceRange": "$$$",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "17:00"
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply - Salt Lake City Surplus Valve Buyers",
          "image": "https://readdy.ai/api/search-image?query=industrial%20refinery%20facility%20with%20large%20steel%20pipes%20valves%20and%20pressure%20gauges%20in%20morning%20light%20professional%20industrial%20equipment%20photography%20clean%20modern%20industrial%20background%20shallow%20depth%20of%20field&width=1920&height=1080&seq=hero-industrial-001&orientation=landscape",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Salt Lake City",
            "addressRegion": "UT",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 40.7608,
            "longitude": -111.8910
          },
          "url": "https://valvesalessupply.com/salt-lake-city",
          "telephone": "+1-214-854-5638",
          "priceRange": "$$$",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "17:00"
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "name": "ValveSalesSupply - Cheyenne Surplus Valve Buyers",
          "image": "https://readdy.ai/api/search-image?query=industrial%20refinery%20facility%20with%20large%20steel%20pipes%20valves%20and%20pressure%20gauges%20in%20morning%20light%20professional%20industrial%20equipment%20photography%20clean%20modern%20industrial%20background%20shallow%20depth%20of%20field&width=1920&height=1080&seq=hero-industrial-001&orientation=landscape",
          "address": {
            "@type": "PostalAddress",
            "addressLocality": "Cheyenne",
            "addressRegion": "WY",
            "addressCountry": "US"
          },
          "geo": {
            "@type": "GeoCoordinates",
            "latitude": 41.1400,
            "longitude": -104.8202
          },
          "url": "https://valvesalessupply.com/cheyenne",
          "telephone": "+1-214-854-5638",
          "priceRange": "$$$",
          "openingHoursSpecification": [
            {
              "@type": "OpeningHoursSpecification",
              "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
              "opens": "08:00",
              "closes": "17:00"
            }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What types of industrial equipment and valves do you buy?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We purchase Fisher control valves, Rosemount transmitters, Grove ball valves, safety relief valves, pipeline valves, General twin seals, pressure gauges, process controls, flow meters, temperature instruments, actuators, positioners, and other industrial instrumentation from refineries, chemical plants, and industrial facilities across Texas, Oklahoma, Louisiana, New Mexico, Kansas, North Dakota, South Dakota, Wyoming, and Utah."
              }
            },
            {
              "@type": "Question",
              "name": "Do you buy Fisher control valves and Rosemount transmitters?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we are major buyers of Fisher control valves including Fisher EZ, Fisher ED, Fisher HP, Fisher DVC6000, and all Fisher valve models. We also purchase Rosemount transmitters including Rosemount 3051, Rosemount 2088, Rosemount 644, Rosemount 8800, and all Rosemount instrumentation. We pay top prices for surplus Fisher and Rosemount equipment."
              }
            },
            {
              "@type": "Question",
              "name": "What brands of safety relief valves and pipeline valves do you purchase?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We buy safety relief valves from Crosby, Anderson Greenwood, Consolidated, Leser, Farris, and Dresser. For pipeline valves, we purchase from Cameron, Velan, Powell, WKM, Grove, and all major manufacturers. We buy ball valves, gate valves, check valves, and plug valves in all sizes from 1 inch to 48 inch."
              }
            },
            {
              "@type": "Question",
              "name": "Which states and cities do you serve as surplus valve buyers?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We serve as surplus valve buyers across 9 states: Texas (Houston, Dallas, Austin, San Antonio, Corpus Christi, El Paso, Beaumont), Oklahoma (Oklahoma City, Tulsa), Louisiana (Baton Rouge, Lake Charles), New Mexico (Albuquerque, Roswell, Hobbs, Artesia), Kansas (Wichita, Topeka, Kansas City), North Dakota (Bismarck, Williston), South Dakota (Sioux Falls, Rapid City), Wyoming (Cheyenne, Casper), and Utah (Salt Lake City, Provo)."
              }
            },
            {
              "@type": "Question",
              "name": "How quickly can you provide a quote for surplus valves and equipment?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "We respond within 24 hours with initial pricing for surplus valves and equipment. Detailed quotes are provided within 48 hours of equipment assessment. For urgent turnaround situations, we can provide same-day quotes and next-day pickup service."
              }
            },
            {
              "@type": "Question",
              "name": "Do you pay above scrap rates for surplus valves and industrial equipment?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we consistently pay 40-60% above scrap market rates for surplus valves and industrial equipment. We leverage our network of buyers, refurbishers, and end users to maximize equipment value. We pay premium prices for Fisher valves, Rosemount transmitters, Grove ball valves, safety relief valves, and all quality industrial equipment."
              }
            },
            {
              "@type": "Question",
              "name": "Do you handle equipment removal, pickup, and transportation?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, we coordinate all logistics including equipment removal, pickup, transportation, and documentation at no additional cost. We provide free pickup service across all 9 states we serve and handle all paperwork and compliance documentation professionally."
              }
            },
            {
              "@type": "Question",
              "name": "What is the process to sell surplus valves to you?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "The process is simple: 1) Contact us by calling (214) 854-5638, emailing valvesalessupply@gmail.com, or submitting your equipment list through our contact form. 2) We review your inventory and provide a detailed quote within 24-48 hours. 3) Accept our offer and we coordinate all pickup and documentation. 4) Receive payment promptly after equipment pickup and verification."
              }
            }
          ]
        }
      ]
    };

    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = JSON.stringify(schemaData);
    document.head.appendChild(script);

    return () => {
      document.head.removeChild(script);
    };
  }, []);

  const brands = [
    {
      name: 'Fisher',
      description: 'Control valves, regulators, and instrumentation',
      link: '/what-we-buy',
      linkText: 'Learn More'
    },
    {
      name: 'Rosemount',
      description: 'Pressure, temperature, and flow transmitters',
      link: '/texas',
      linkText: 'Texas Locations'
    },
    {
      name: 'Foxboro',
      description: 'Process control and automation equipment',
      link: '/oklahoma',
      linkText: 'Oklahoma Service'
    },
    {
      name: 'Honeywell',
      description: 'Analyzers, recorders, and control systems',
      link: '/louisiana',
      linkText: 'Louisiana Areas'
    },
    {
      name: 'Yokogawa',
      description: 'Flow meters, recorders, and transmitters',
      link: '/houston',
      linkText: 'Houston Service'
    },
    {
      name: 'ABB',
      description: 'Analytical instruments and flow measurement',
      link: '/dallas',
      linkText: 'Dallas Region'
    }
  ];

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Breadcrumbs */}
      <nav className="bg-gray-50 border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 py-3">
          <ol className="flex items-center space-x-2 text-sm">
            <li>
              <Link to="/" className="text-teal-600 hover:text-teal-700 font-medium">
                Home
              </Link>
            </li>
          </ol>
        </div>
      </nav>

      {/* Hero Section */}
      <section className="relative min-h-screen flex items-center pt-20">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{
            backgroundImage: `url('https://readdy.ai/api/search-image?query=industrial%20refinery%20facility%20with%20large%20steel%20pipes%20valves%20and%20pressure%20gauges%20in%20morning%20light%20professional%20industrial%20equipment%20photography%20clean%20modern%20industrial%20background%20shallow%20depth%20of%20field&width=1920&height=1080&seq=hero-industrial-001&orientation=landscape')`
          }}
          role="img"
          aria-label="Industrial refinery facility with steel pipes, valves and pressure gauges - ValveSalesSupply equipment purchasing services"
        >
          <div className="absolute inset-0 bg-gradient-to-b from-[#1B3A5F]/50 via-[#1B3A5F]/40 to-[#1B3A5F]/50"></div>
        </div>
        
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 w-full py-12 sm:py-0">
          <div className="max-w-2xl">
            <div className="bg-red-600 text-white px-4 py-2 rounded-full inline-block mb-4 animate-pulse">
              <i className="ri-fire-line mr-2"></i>
              PAYING HIGHEST PRICE IN THE INDUSTRY
            </div>
            <p className="text-white/80 uppercase text-xs sm:text-sm font-semibold mb-3 sm:mb-4 tracking-[2px]">
              URGENT: PLANT TURNAROUNDS STARTING - WE NEED YOUR SURPLUS
            </p>
            <h1 className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-4 sm:mb-6">
              We Buy Valves
            </h1>
            <div className="bg-yellow-400 text-black p-4 rounded-lg mb-6 font-bold">
              <div className="text-lg mb-2">⚡ SAME-DAY CASH OFFERS ⚡</div>
              <div className="text-sm">Call before 3PM - Get quote same day, pickup tomorrow</div>
            </div>
            <div className="text-gray-200 text-sm sm:text-base md:text-lg lg:text-xl mb-6 sm:mb-10 flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-0 sm:space-x-4">
              <span>✓ No Quantity Too Small</span>
              <span className="hidden sm:block w-2 h-2 bg-white rounded-full"></span>
              <span>✓ Free Pickup & Documentation</span>
              <span className="hidden sm:block w-2 h-2 bg-white rounded-full"></span>
              <span>✓ Cash Payment On Pickup</span>
            </div>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-5">
              <a
                href="tel:214-854-5638"
                className="bg-red-600 text-white px-6 sm:px-8 py-3 sm:py-4 rounded-2xl font-bold text-base sm:text-lg hover:bg-red-700 transition-all duration-300 flex items-center justify-center whitespace-nowrap animate-bounce"
              >
                <i className="ri-phone-line mr-2"></i>
                CALL NOW: (214) 854-5638
              </a>
              <Link
                to="/contact"
                className="border-2 border-white text-white px-6 sm:px-8 py-3 sm:py-4 rounded-2xl font-semibold text-base sm:text-lg hover:bg-white hover:text-[#1B3A5F] transition-all duration-300 flex items-center justify-center whitespace-nowrap"
              >
                TEXT PHOTOS FOR INSTANT QUOTE
                <i className="ri-arrow-right-line ml-2"></i>
              </Link>
            </div>

            <div className="mt-8 bg-white/10 backdrop-blur-sm rounded-lg p-4">
              <div className="text-white text-sm mb-2">🔥 HOT DEMAND RIGHT NOW:</div>
              <div className="grid grid-cols-2 gap-2 text-xs text-white/90">
                <div>• Fisher Control Valves</div>
                <div>• Grove Ball Valves</div>
                <div>• Rosemount Transmitters</div>
                <div>• Safety Relief Valves</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What We Buy Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center mb-16">What We Buy</h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition-shadow">
              <i className="ri-settings-2-line text-4xl text-teal-600 mb-4"></i>
              <h3 className="text-xl font-semibold mb-3">Control Valves</h3>
              <p className="text-gray-600">Fisher, Masoneilan, Valtek, and other major brands</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition-shadow">
              <i className="ri-dashboard-line text-4xl text-teal-600 mb-4"></i>
              <h3 className="text-xl font-semibold mb-3">Instrumentation</h3>
              <p className="text-gray-600">Rosemount, Foxboro, transmitters, and measuring devices</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition-shadow">
              <i className="ri-water-flash-line text-4xl text-teal-600 mb-4"></i>
              <h3 className="text-xl font-semibold mb-3">Flow Meters</h3>
              <p className="text-gray-600">Bager, Rockwell, Neptune, and precision flow equipment</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition-shadow">
              <i className="ri-shut-down-line text-4xl text-teal-600 mb-4"></i>
              <h3 className="text-xl font-semibold mb-3">Ball & Gate Valves</h3>
              <p className="text-gray-600">Q-Check, Warren, CF Fluid Controls, and industrial valves</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition-shadow">
              <i className="ri-copper-coin-line text-4xl text-teal-600 mb-4"></i>
              <h3 className="text-xl font-semibold mb-3">Scrap Metal</h3>
              <p className="text-gray-600">Copper, brass, alloy, stainless steel, and metal components</p>
            </div>
            <div className="bg-white p-6 rounded-lg shadow-lg text-center hover:shadow-xl transition-shadow">
              <i className="ri-flashlight-line text-4xl text-teal-600 mb-4"></i>
              <h3 className="text-xl font-semibold mb-3">Electrical Surplus</h3>
              <p className="text-gray-600">Motors, wire, electrical components, and surplus equipment</p>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment Brands We Buy Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-3xl font-bold mb-4">Premium Equipment Brands We Purchase</h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We specialize in acquiring top-tier industrial equipment from leading manufacturers. 
              Sell us your surplus inventory from these trusted brands.
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Valves & Controls */}
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-center mb-4">
                <i className="ri-settings-4-line text-2xl text-teal-600 mr-3"></i>
                <h3 className="text-xl font-bold">Valves & Controls</h3>
              </div>
              <div className="space-y-2 text-gray-700">
                <p><strong>Control Valves:</strong> Fisher, Masoneilan, Valtek, Flowseal</p>
                <p><strong>Relief Valves:</strong> Q-Check, Centerline, Edwards</p>
                <p><strong>Specialty:</strong> Rosemount, WKM, General Twinseal, Tufline, Orbit, Durco</p>
              </div>
              <div className="mt-4 space-x-2">
                <Link to="/what-we-buy" className="inline-block bg-teal-600 text-white px-4 py-2 rounded hover:bg-teal-700 transition-colors text-sm">
                  Learn More
                </Link>
                <Link to="/contact" className="inline-block border border-teal-600 text-teal-600 px-4 py-2 rounded hover:bg-teal-50 transition-colors text-sm">
                  Get Quote
                </Link>
              </div>
            </div>

            {/* Instrumentation */}
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-center mb-4">
                <i className="ri-dashboard-3-line text-2xl text-teal-600 mr-3"></i>
                <h3 className="text-xl font-bold">Instrumentation</h3>
              </div>
              <div className="space-y-2 text-gray-700">
                <p><strong>Transmitters:</strong> Rosemount, Foxboro, Fisher, Taylor</p>
                <p><strong>Controllers:</strong> Fisher, Q-Check, Valtek</p>
                <p><strong>Recorders:</strong> Fisher, Foxboro systems</p>
              </div>
              <div className="mt-4 space-x-2">
                <Link to="/texas" className="inline-block bg-teal-600 text-white px-4 py-2 rounded hover:bg-teal-700 transition-colors text-sm">
                  Texas Locations
                </Link>
                <Link to="/contact" className="inline-block border border-teal-600 text-teal-600 px-4 py-2 rounded hover:bg-teal-50 transition-colors text-sm">
                  Get Quote
                </Link>
              </div>
            </div>

            {/* Flow Measurement */}
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-center mb-4">
                <i className="ri-water-flash-line text-2xl text-teal-600 mr-3"></i>
                <h3 className="text-xl font-bold">Flow Measurement</h3>
              </div>
              <div className="space-y-2 text-gray-700">
                <p><strong>Water Meters:</strong> Bager, Rockwell, Neptune</p>
                <p><strong>Thermowells:</strong> WIKA, All Temp Sensors, OCI</p>
                <p><strong>Gauges:</strong> McDaniel, precision instruments</p>
              </div>
              <div className="mt-4 space-x-2">
                <Link to="/oklahoma" className="inline-block bg-teal-600 text-white px-4 py-2 rounded hover:bg-teal-700 transition-colors text-sm">
                  Oklahoma Service
                </Link>
                <Link to="/contact" className="inline-block border border-teal-600 text-teal-600 px-4 py-2 rounded hover:bg-teal-50 transition-colors text-sm">
                  Get Quote
                </Link>
              </div>
            </div>

            {/* Actuators & Positioners */}
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-center mb-4">
                <i className="ri-cpu-line text-2xl text-teal-600 mr-3"></i>
                <h3 className="text-xl font-bold">Actuators & Positioners</h3>
              </div>
              <div className="space-y-2 text-gray-700">
                <p><strong>Actuators:</strong> Fisher, Limitorque, Masoneilan, Bettis</p>
                <p><strong>Positioners:</strong> Fisher, Foxboro precision units</p>
                <p><strong>Regulators:</strong> Fisher, Conoflow, Control Air</p>
              </div>
              <div className="mt-4 space-x-2">
                <Link to="/louisiana" className="inline-block bg-teal-600 text-white px-4 py-2 rounded hover:bg-teal-700 transition-colors text-sm">
                  Louisiana Areas
                </Link>
                <Link to="/contact" className="inline-block border border-teal-600 text-teal-600 px-4 py-2 rounded hover:bg-teal-50 transition-colors text-sm">
                  Get Quote
                </Link>
              </div>
            </div>

            {/* Fittings & Connections */}
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-center mb-4">
                <i className="ri-link text-2xl text-teal-600 mr-3"></i>
                <h3 className="text-xl font-bold">Fittings & Connections</h3>
              </div>
              <div className="space-y-2 text-gray-700">
                <p><strong>Precision Fittings:</strong> Parker, Swagelok systems</p>
                <p><strong>Manifolds:</strong> Anderson Greenwood, Hoke</p>
                <p><strong>Pipe & Flanges:</strong> Industrial grade connections</p>
              </div>
              <div className="mt-4 space-x-2">
                <Link to="/houston" className="inline-block bg-teal-600 text-white px-4 py-2 rounded hover:bg-teal-700 transition-colors text-sm">
                  Houston Service
                </Link>
                <Link to="/contact" className="inline-block border border-teal-600 text-teal-600 px-4 py-2 rounded hover:bg-teal-50 transition-colors text-sm">
                  Get Quote
                </Link>
              </div>
            </div>

            {/* Industrial Valves */}
            <div className="bg-gray-50 p-6 rounded-lg">
              <div className="flex items-center mb-4">
                <i className="ri-shut-down-line text-2xl text-teal-600 mr-3"></i>
                <h3 className="text-xl font-bold">Industrial Valves</h3>
              </div>
              <div className="space-y-2 text-gray-700">
                <p><strong>Ball/Butterfly:</strong> Q-Check, Dafram, CF Fluid Controls</p>
                <p><strong>Gate/Check:</strong> Warren, Chemvalve, Flocheck</p>
                <p><strong>Lined Plug:</strong> Q-Check, Chemvalve specialty</p>
              </div>
              <div className="mt-4 space-x-2">
                <Link to="/dallas" className="inline-block bg-teal-600 text-white px-4 py-2 rounded hover:bg-teal-700 transition-colors text-sm">
                  Dallas Region
                </Link>
                <Link to="/contact" className="inline-block border border-teal-600 text-teal-600 px-4 py-2 rounded hover:bg-teal-50 transition-colors text-sm">
                  Get Quote
                </Link>
              </div>
            </div>
          </div>

          {/* Additional Materials */}
          <div className="mt-12 bg-teal-50 p-8 rounded-lg">
            <h3 className="text-2xl font-bold text-center mb-8">We Also Purchase</h3>
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 text-center">
              <div>
                <i className="ri-copper-coin-line text-3xl text-teal-600 mb-3"></i>
                <h4 className="font-semibold mb-2">Scrap Metals</h4>
                <p className="text-gray-600">Copper, Brass, Alloy, Stainless Steel</p>
              </div>
              <div>
                <i className="ri-flashlight-line text-3xl text-teal-600 mb-3"></i>
                <h4 className="font-semibold mb-2">Electrical Surplus</h4>
                <p className="text-gray-600">Motors (all types), Wire, Components</p>
              </div>
              <div>
                <i className="ri-tools-line text-3xl text-teal-600 mb-3"></i>
                <h4 className="font-semibold mb-2">Transducers</h4>
                <p className="text-gray-600">Fisher, Rosemount, Masoneilan, Valtek</p>
              </div>
              <div>
                <i className="ri-temp-hot-line text-3xl text-teal-600 mb-3"></i>
                <h4 className="font-semibold mb-2">Temperature</h4>
                <p className="text-gray-600">RTD sensors, Thermowells, Gauges</p>
              </div>
            </div>
          </div>

          {/* Call to Action */}
          <div className="text-center mt-12">
            <h3 className="text-2xl font-bold mb-4">Ready to Sell Your Equipment?</h3>
            <p className="text-gray-600 mb-6 max-w-2xl mx-auto">
              Get top dollar for your surplus industrial equipment. We buy from refineries, chemical plants, 
              and industrial facilities across 9 states.
            </p>
            <div className="space-x-4">
              <a 
                href="tel:(214) 854-5638"
                className="inline-block bg-teal-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors"
              >
                Call (214) 854-5638
              </a>
              <a 
                href="/contact"
                className="inline-block border-2 border-teal-600 text-teal-600 px-8 py-3 rounded-lg font-semibold hover:bg-teal-50 transition-colors"
              >
                Get Free Quote
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Equipment Categories */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Premium Industrial Equipment We Buy
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We purchase high-quality used and surplus equipment from top manufacturers including Fisher, Rosemount, Grove, General, and more
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Fisher Control Valves */}
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-64 w-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20industrial%20Fisher%20control%20valves%20and%20Masoneilan%20control%20valves%20arranged%20on%20clean%20white%20surface%20with%20soft%20studio%20lighting%20showing%20valve%20bodies%20actuators%20and%20positioners%20in%20pristine%20condition%20high%20quality%20industrial%20equipment%20photography%20with%20neutral%20gray%20background&width=400&height=300&seq=fisher-valves-home-1&orientation=landscape"
                  alt="We Buy Surplus Fisher Control Valves and Masoneilan Control Valves - Industrial Process Control Valves"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  Fisher Control Valves
                </h3>
                <p className="text-gray-600 mb-4">
                  Fisher control valves, Masoneilan valves, Valtek valves, and other premium control valve brands. All sizes and configurations accepted.
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium">Fisher</span>
                  <span className="px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium">Masoneilan</span>
                  <span className="px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium">Valtek</span>
                </div>
                <a
                  href="/contact"
                  className="inline-flex items-center text-teal-600 hover:text-teal-700 font-semibold whitespace-nowrap cursor-pointer"
                >
                  Get Quote <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>

            {/* Rosemount Transmitters */}
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-64 w-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20Rosemount%20pressure%20transmitters%20and%20temperature%20transmitters%20displayed%20on%20clean%20white%20surface%20showing%20digital%20displays%20and%20process%20connections%20industrial%20instrumentation%20equipment%20high%20quality%20product%20photography%20with%20soft%20lighting%20and%20neutral%20background&width=400&height=300&seq=rosemount-transmitters-home-1&orientation=landscape"
                  alt="We Buy Surplus Rosemount Transmitters and Foxboro Instrumentation - Industrial Process Transmitters"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  Rosemount Instrumentation
                </h3>
                <p className="text-gray-600 mb-4">
                  Rosemount transmitters, Foxboro instrumentation, Fisher instruments, and Barton recorders. All models and conditions.
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium">Rosemount</span>
                  <span className="px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium">Foxboro</span>
                  <span className="px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium">Fisher</span>
                </div>
                <a
                  href="/contact"
                  className="inline-flex items-center text-teal-600 hover:text-teal-700 font-semibold whitespace-nowrap cursor-pointer"
                >
                  Get Quote <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>

            {/* Grove Ball Valves */}
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-64 w-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20Grove%20ball%20valves%20and%20pipeline%20valves%20in%20various%20sizes%20displayed%20on%20clean%20white%20surface%20showing%20valve%20handles%20flanges%20and%20bodies%20industrial%20pipeline%20equipment%20high%20quality%20product%20photography%20with%20studio%20lighting%20and%20neutral%20gray%20background&width=400&height=300&seq=grove-ball-valves-home-1&orientation=landscape"
                  alt="We Buy Surplus Grove Ball Valves and Pipeline Valves - Industrial Ball Valves and Gate Valves"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  Grove Ball & Pipeline Valves
                </h3>
                <p className="text-gray-600 mb-4">
                  Grove ball valves, Grove pipeline valves, WKM valves, and other specialty ball and gate valves. All sizes from 1" to 48".
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium">Grove</span>
                  <span className="px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium">WKM</span>
                  <span className="px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium">Ball Valves</span>
                </div>
                <a
                  href="/contact"
                  className="inline-flex items-center text-teal-600 hover:text-teal-700 font-semibold whitespace-nowrap cursor-pointer"
                >
                  Get Quote <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>

            {/* Safety Relief Valves */}
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-64 w-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20industrial%20safety%20relief%20valves%20and%20pressure%20relief%20valves%20arranged%20on%20clean%20white%20surface%20showing%20spring%20loaded%20mechanisms%20and%20valve%20bodies%20in%20various%20sizes%20high%20quality%20industrial%20equipment%20photography%20with%20soft%20studio%20lighting%20and%20neutral%20background&width=400&height=300&seq=safety-relief-valves-home-1&orientation=landscape"
                  alt="We Buy Surplus Safety Relief Valves and Pressure Relief Valves - Industrial Safety Valves"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  Safety Relief Valves
                </h3>
                <p className="text-gray-600 mb-4">
                  Safety relief valves, pressure relief valves, and pop-off valves from all major manufacturers. All pressure ratings and sizes.
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium">Safety Valves</span>
                  <span className="px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium">Relief Valves</span>
                  <span className="px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium">All Brands</span>
                </div>
                <a
                  href="/contact"
                  className="inline-flex items-center text-teal-600 hover:text-teal-700 font-semibold whitespace-nowrap cursor-pointer"
                >
                  Get Quote <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>

            {/* General Twin Seals */}
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-64 w-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20General%20twin%20seal%20mechanical%20seals%20and%20dual%20seals%20displayed%20on%20clean%20white%20surface%20showing%20seal%20faces%20springs%20and%20housing%20components%20industrial%20pump%20seals%20high%20quality%20product%20photography%20with%20studio%20lighting%20and%20neutral%20gray%20background&width=400&height=300&seq=general-twin-seals-home-1&orientation=landscape"
                  alt="We Buy Surplus General Twin Seals and Mechanical Seals - Industrial Pump Seals and Dual Seals"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  General Twin Seals
                </h3>
                <p className="text-gray-600 mb-4">
                  General twin seals, mechanical seals, dual seals, and cartridge seals. All sizes and configurations for pumps and rotating equipment.
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium">General</span>
                  <span className="px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium">Twin Seals</span>
                  <span className="px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium">Mechanical Seals</span>
                </div>
                <a
                  href="/contact"
                  className="inline-flex items-center text-teal-600 hover:text-teal-700 font-semibold whitespace-nowrap cursor-pointer"
                >
                  Get Quote <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>

            {/* Actuators & Positioners */}
            <div className="bg-gradient-to-br from-gray-50 to-white rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
              <div className="h-64 w-full overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=Professional%20Limitorque%20electric%20actuators%20and%20Bettis%20pneumatic%20actuators%20with%20Fisher%20valve%20positioners%20displayed%20on%20clean%20white%20surface%20industrial%20valve%20automation%20equipment%20high%20quality%20product%20photography%20with%20soft%20lighting%20and%20neutral%20background&width=400&height=300&seq=actuators-home-2&orientation=landscape"
                  alt="We Buy Surplus Limitorque Actuators and Bettis Actuators - Industrial Valve Actuators and Positioners"
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="p-6">
                <h3 className="text-2xl font-bold text-gray-900 mb-3">
                  Actuators & Positioners
                </h3>
                <p className="text-gray-600 mb-4">
                  Limitorque electric actuators, Bettis pneumatic actuators, Fisher positioners, and Foxboro valve controllers.
                </p>
                <div className="flex flex-wrap gap-2 mb-4">
                  <span className="px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium">Limitorque</span>
                  <span className="px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium">Bettis</span>
                  <span className="px-3 py-1 bg-teal-100 text-teal-800 rounded-full text-sm font-medium">Fisher</span>
                </div>
                <a
                  href="/contact"
                  className="inline-flex items-center text-teal-600 hover:text-teal-700 font-semibold whitespace-nowrap cursor-pointer"
                >
                  Get Quote <i className="ri-arrow-right-line ml-2"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="py-16 sm:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">How It Works</h2>
            <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
              Our streamlined process makes selling your surplus equipment simple and profitable
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 sm:gap-8">
            {[
              {
                step: '01',
                title: 'Contact Us',
                description: 'Call, email, or submit your equipment list through our contact form',
                icon: 'ri-phone-line'
              },
              {
                step: '02',
                title: 'Equipment Assessment',
                description: 'We review your inventory and provide a detailed quote within 24-48 hours',
                icon: 'ri-file-list-3-line'
              },
              {
                step: '03',
                title: 'Agreement & Logistics',
                description: 'Accept our offer and we coordinate all pickup and documentation',
                icon: 'ri-truck-line'
              },
              {
                step: '04',
                title: 'Fast Payment',
                description: 'Receive payment promptly after equipment pickup and verification',
                icon: 'ri-money-dollar-circle-line'
              }
            ].map((step, index) => (
              <div key={index} className="relative">
                <div className="bg-white rounded-2xl p-6 sm:p-8 h-full hover:shadow-lg transition-all duration-300">
                  <div className="text-[#1B3A5F] text-4xl sm:text-5xl font-bold mb-4 opacity-20">{step.step}</div>
                  <div className="w-12 h-12 flex items-center justify-center bg-[#1B3A5F] rounded-xl mb-4">
                    <i className={`${step.icon} text-xl text-white`}></i>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">{step.title}</h3>
                  <p className="text-gray-600">{step.description}</p>
                </div>
                {index < 3 && (
                  <div className="hidden md:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                    <i className="ri-arrow-right-line text-2xl text-[#1B3A5F]"></i>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="text-center mt-10 sm:mt-12">
            <Link
              to="/how-it-works"
              className="inline-flex items-center text-[#1B3A5F] font-semibold hover:underline whitespace-nowrap"
            >
              Learn More About Our Process
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Service Areas Section */}
      <section className="py-16 sm:py-24 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">Service Areas</h2>
            <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
              We serve industrial facilities across 9 states in the central United States
            </p>
          </div>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 sm:gap-6 mb-10 sm:mb-12">
            {[
              { name: 'Texas', cities: 'Houston, Dallas, Austin, San Antonio', link: '/texas' },
              { name: 'Oklahoma', cities: 'Oklahoma City, Tulsa', link: '/oklahoma' },
              { name: 'Louisiana', cities: 'Baton Rouge, Lake Charles', link: '/louisiana' },
              { name: 'New Mexico', cities: 'Albuquerque, Roswell, Hobbs', link: '/new-mexico' },
              { name: 'Kansas', cities: 'Wichita, Topeka, Kansas City', link: '/kansas' },
              { name: 'North Dakota', cities: 'Bismarck, Williston', link: '/north-dakota' },
              { name: 'South Dakota', cities: 'Sioux Falls, Rapid City', link: '/south-dakota' },
              { name: 'Wyoming', cities: 'Cheyenne, Casper', link: '/wyoming' },
              { name: 'Utah', cities: 'Salt Lake City, Provo', link: '/utah' }
            ].map((state, index) => (
              <Link
                key={index}
                to={state.link}
                className="bg-gray-50 rounded-xl p-4 sm:p-6 hover:shadow-lg transition-all duration-300 group"
              >
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 group-hover:text-[#1B3A5F]">
                  {state.name}
                </h3>
                <p className="text-sm text-gray-600">{state.cities}</p>
              </Link>
            ))}
          </div>

          <div className="text-center">
            <Link
              to="/service-areas"
              className="inline-flex items-center text-[#1B3A5F] font-semibold hover:underline whitespace-nowrap"
            >
              View All Service Areas
              <i className="ri-arrow-right-line ml-2"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-16 sm:py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">Why Choose ValveSalesSupply</h2>
            <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
              We offer more value than scrap yards and faster service than traditional brokers
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {[
              {
                icon: 'ri-money-dollar-circle-line',
                title: 'Above Scrap Rates',
                description: 'We pay significantly more than scrap value by leveraging our network of buyers and refurbishers'
              },
              {
                icon: 'ri-time-line',
                title: '24-Hour Response',
                description: 'Quick turnaround on quotes and assessments to meet your project timelines'
              },
              {
                icon: 'ri-file-text-line',
                title: 'Professional Documentation',
                description: 'Complete paperwork, certifications, and compliance documentation handled for you'
              },
              {
                icon: 'ri-truck-line',
                title: 'Logistics Coordination',
                description: 'We handle all pickup, transportation, and logistics at no additional cost'
              },
              {
                icon: 'ri-shield-check-line',
                title: 'Trusted & Reliable',
                description: '25+ years of experience serving refineries and industrial facilities'
              },
              {
                icon: 'ri-team-line',
                title: 'Expert Team',
                description: 'Knowledgeable staff who understand industrial equipment and your needs'
              }
            ].map((benefit, index) => (
              <div key={index} className="bg-white rounded-2xl p-6 sm:p-8 hover:shadow-lg transition-all duration-300">
                <div className="w-14 h-14 flex items-center justify-center bg-[#1B3A5F] rounded-xl mb-4 sm:mb-6">
                  <i className={`${benefit.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{benefit.title}</h3>
                <p className="text-gray-600">{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-16 sm:py-24 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6">
          <div className="text-center mb-12 sm:mb-16">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">Frequently Asked Questions</h2>
          </div>

          <div className="space-y-4 sm:space-y-6">
            {[
              {
                question: 'What types of industrial equipment do you buy?',
                answer: 'We purchase control valves, pressure gauges, process controls, flow meters, temperature instruments, safety equipment, and other industrial instrumentation from refineries, chemical plants, and industrial facilities.'
              },
              {
                question: 'How quickly can you provide a quote?',
                answer: 'We respond within 24 hours with initial pricing and can provide detailed quotes within 48 hours of equipment assessment.'
              },
              {
                question: 'Do you pay above scrap rates?',
                answer: 'Yes, we consistently pay above scrap market rates by leveraging our network of buyers, refurbishers, and end users to maximize equipment value.'
              },
              {
                question: 'What condition does equipment need to be in?',
                answer: 'We buy equipment in various conditions - from like-new surplus to used equipment. Even non-functional items may have value for parts or refurbishment.'
              },
              {
                question: 'Do you handle equipment removal and transportation?',
                answer: 'Yes, we coordinate all logistics including equipment removal, transportation, and any necessary documentation at no additional cost to you.'
              },
              {
                question: 'How do I get started?',
                answer: 'Simply call us at (214) 854-5638, email valvesalessupply@gmail.com, or submit your equipment list through our contact form. We\'ll respond within 24 hours.'
              }
            ].map((faq, index) => (
              <div key={index} className="bg-gray-50 rounded-xl p-6 sm:p-8">
                <h3 className="text-lg sm:text-xl font-bold text-gray-900 mb-3">{faq.question}</h3>
                <p className="text-gray-600">{faq.answer}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* PAIN POINT SOLUTIONS */}
      <section className="py-16 bg-gray-900 text-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4 text-red-400">STOP LOSING MONEY ON YOUR SURPLUS</h2>
            <p className="text-xl text-gray-300">We solve the problems other buyers can't</p>
          </div>
          
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="bg-red-600/10 border border-red-500 p-6 rounded-xl">
              <h3 className="text-2xl font-bold text-red-400 mb-4">❌ TIRED OF THESE PROBLEMS?</h3>
              <ul className="space-y-3 text-gray-300">
                <li>• Scrap yards offering pennies on the dollar</li>
                <li>• Buyers who disappear after seeing equipment</li>
                <li>• Months waiting for other companies to respond</li>
                <li>• Complex paperwork and documentation hassles</li>
                <li>• Equipment sitting and deteriorating</li>
                <li>• Management pressure to clear space NOW</li>
              </ul>
            </div>
            
            <div className="bg-green-600/10 border border-green-500 p-6 rounded-xl">
              <h3 className="text-2xl font-bold text-green-400 mb-4">✅ WE SOLVE ALL OF THIS</h3>
              <ul className="space-y-3 text-gray-300">
                <li>• Pay 40-60% MORE than scrap rates</li>
                <li>• Quote within 24 hours, pickup next day</li>
                <li>• 25+ years of reliable service</li>
                <li>• We handle ALL paperwork</li>
                <li>• Cash payment on pickup</li>
                <li>• Clear your space in 48 hours</li>
              </ul>
            </div>
          </div>
          
          <div className="text-center bg-gradient-to-r from-green-600 to-green-700 p-8 rounded-xl">
            <h3 className="text-3xl font-bold mb-4">TURN YOUR PROBLEM INTO PROFIT</h3>
            <p className="text-xl mb-6 text-green-100">
              Don't let valuable equipment become a liability. One call turns your surplus into cash.
            </p>
            <a
              href="tel:214-854-5638"
              className="bg-yellow-400 text-black px-8 py-4 rounded-xl font-bold text-xl hover:bg-yellow-300 transition-all duration-300 inline-block animate-pulse"
            >
              CALL NOW: (214) 854-5638
            </a>
          </div>
        </div>
      </section>

      {/* Urgent Buying Alert */}
      <div className="bg-gradient-to-r from-red-600 to-orange-600 text-white p-8 rounded-xl shadow-2xl mb-8">
        <div className="text-center mb-6">
          <div className="inline-flex items-center bg-yellow-400 text-black px-4 py-2 rounded-full text-sm font-bold mb-4 animate-pulse">
            🚨 HOT DEMAND ALERT
          </div>
          <h2 className="text-3xl font-bold mb-4">WE'RE PAYING PREMIUM PRICES RIGHT NOW!</h2>
          <p className="text-xl mb-4">Current Market: <span className="text-yellow-400 font-bold">40-60% ABOVE SCRAP RATES</span></p>
        </div>
        
        <div className="grid md:grid-cols-3 gap-6 mb-6">
          <div className="bg-white/10 p-4 rounded-lg text-center">
            <div className="text-2xl font-bold text-yellow-400">$15,000+</div>
            <div className="text-sm">Fisher Control Valves</div>
            <div className="text-xs text-yellow-300">3 BUYERS COMPETING</div>
          </div>
          <div className="bg-white/10 p-4 rounded-lg text-center">
            <div className="text-2xl font-bold text-yellow-400">$25,000+</div>
            <div className="text-sm">Grove Ball Valves</div>
            <div className="text-xs text-yellow-300">URGENT NEED</div>
          </div>
          <div className="bg-white/10 p-4 rounded-lg text-center">
            <div className="text-2xl font-bold text-yellow-400">$8,000+</div>
            <div className="text-sm">Rosemount Transmitters</div>
            <div className="text-xs text-yellow-300">IMMEDIATE PICKUP</div>
          </div>
        </div>

        <div className="text-center">
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <a href="tel:214-854-5638" 
               className="bg-yellow-400 text-black px-8 py-4 rounded-lg font-bold text-lg hover:bg-yellow-300 transition-colors animate-pulse whitespace-nowrap">
              📞 CALL NOW: (214) 854-5638
            </a>
            <div className="text-center">
              <div className="text-sm">Or text photos for instant quote:</div>
              <a href="sms:214-854-5638" className="text-yellow-400 font-bold hover:text-yellow-300">(214) 854-5638</a>
            </div>
          </div>
          <p className="text-sm mt-2 opacity-90">✅ Same Day Cash Offers • ✅ Free Pickup • ✅ No Paperwork Hassles</p>
        </div>
      </div>

      {/* Final Urgent CTA */}
      <section className="py-16 sm:py-24 bg-gradient-to-r from-red-700 to-red-800 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 text-center">
          <div className="bg-yellow-400 text-black px-6 py-3 rounded-full inline-block mb-6 animate-bounce">
            <span className="font-bold text-lg">⏰ DON'T WAIT - PRICES ARE RISING DAILY</span>
          </div>
          
          <h2 className="text-3xl sm:text-4xl font-bold mb-4 sm:mb-6">
            GET PAID TODAY FOR EQUIPMENT COLLECTING DUST
          </h2>
          <p className="text-lg sm:text-xl text-red-100 mb-8 sm:mb-10">
            Every day you wait, that equipment loses value. Call now and get cash tomorrow.
          </p>
          
          <div className="bg-black/30 p-6 rounded-xl mb-8">
            <div className="text-lg font-bold mb-2">📞 CALL NOW: (214) 854-5638</div>
            <div className="text-sm text-red-100">
              Available 7 days a week. Emergency turnaround support 24/7.
            </div>
          </div>
          
          <div className="flex flex-col sm:flex-row gap-4 sm:gap-5 justify-center">
            <a
              href="tel:214-854-5638"
              className="bg-yellow-400 text-black px-8 py-4 rounded-2xl font-bold text-lg hover:bg-yellow-300 transition-all duration-300 flex items-center justify-center whitespace-nowrap"
            >
              <i className="ri-phone-line mr-2"></i>
              CALL NOW: (214) 854-5638
            </a>
            <a
              href="mailto:valvesalessupply@gmail.com"
              className="bg-green-600 text-white px-8 py-4 rounded-2xl font-bold text-lg hover:bg-green-700 transition-all duration-300 flex items-center justify-center whitespace-nowrap"
            >
              <i className="ri-mail-line mr-2"></i>
              EMAIL EQUIPMENT PHOTOS
            </a>
          </div>
        </div>
      </section>

      {/* Premium Equipment Brands We Purchase */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-bold text-gray-900 mb-4">
              Premium Equipment Brands We Purchase
            </h2>
            <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              We buy top-quality industrial equipment from leading manufacturers across all major categories
            </p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
            {/* Valves & Controls */}
            <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-xl border border-gray-200 hover:shadow-xl transition-all duration-300">
              <div className="flex items-center mb-4">
                <i className="ri-settings-3-line text-3xl text-teal-600 mr-3"></i>
                <h3 className="text-2xl font-bold text-gray-900">Valves & Controls</h3>
              </div>
              <div className="space-y-2 mb-6">
                <p className="text-gray-700"><strong>Fisher</strong> - Control valves, regulators, actuators</p>
                <p className="text-gray-700"><strong>Masoneilan</strong> - Control valves, positioners</p>
                <p className="text-gray-700"><strong>Valtek</strong> - Severe service valves</p>
                <p className="text-gray-700"><strong>Q-Check</strong> - Check valves, ball valves</p>
                <p className="text-gray-700"><strong>Flowseal</strong> - Lined butterfly valves</p>
                <p className="text-gray-700"><strong>Centerline</strong> - Butterfly valves</p>
                <p className="text-gray-700"><strong>WKM</strong> - Gate valves, ball valves</p>
                <p className="text-gray-700"><strong>Edwards</strong> - Relief valves</p>
              </div>
              <div className="flex flex-wrap gap-2 mb-4">
                <Link to="/texas" className="text-sm text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap">Texas</Link>
                <span className="text-gray-400">•</span>
                <Link to="/oklahoma" className="text-sm text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap">Oklahoma</Link>
                <span className="text-gray-400">•</span>
                <Link to="/houston" className="text-sm text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap">Houston</Link>
              </div>
            </div>

            {/* Instrumentation */}
            <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-xl border border-gray-200 hover:shadow-xl transition-all duration-300">
              <div className="flex items-center mb-4">
                <i className="ri-dashboard-line text-3xl text-teal-600 mr-3"></i>
                <h3 className="text-2xl font-bold text-gray-900">Instrumentation</h3>
              </div>
              <div className="space-y-2 mb-6">
                <p className="text-gray-700"><strong>Rosemount</strong> - Transmitters, pressure sensors</p>
                <p className="text-gray-700"><strong>Foxboro</strong> - Controllers, recorders, transmitters</p>
                <p className="text-gray-700"><strong>Fisher</strong> - Transmitters, controllers</p>
                <p className="text-gray-700"><strong>Barton</strong> - Pressure instruments</p>
                <p className="text-gray-700"><strong>Taylor</strong> - Temperature recorders</p>
              </div>
              <div className="flex flex-wrap gap-2 mb-4">
                <Link to="/texas" className="text-sm text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap">Texas</Link>
                <span className="text-gray-400">•</span>
                <Link to="/oklahoma" className="text-sm text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap">Oklahoma</Link>
                <span className="text-gray-400">•</span>
                <Link to="/louisiana" className="text-sm text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap">Louisiana</Link>
              </div>
            </div>

            {/* Flow Measurement */}
            <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-xl border border-gray-200 hover:shadow-xl transition-all duration-300">
              <div className="flex items-center mb-4">
                <i className="ri-water-flash-line text-3xl text-teal-600 mr-3"></i>
                <h3 className="text-2xl font-bold text-gray-900">Flow Measurement</h3>
              </div>
              <div className="space-y-2 mb-6">
                <p className="text-gray-700"><strong>Badger</strong> - Water meters, flow meters</p>
                <p className="text-gray-700"><strong>Rockwell</strong> - Industrial meters</p>
                <p className="text-gray-700"><strong>Neptune</strong> - Water measurement systems</p>
              </div>
              <div className="flex flex-wrap gap-2 mb-4">
                <Link to="/texas" className="text-sm text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap">Texas</Link>
                <span className="text-gray-400">•</span>
                <Link to="/oklahoma" className="text-sm text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap">Oklahoma</Link>
                <span className="text-gray-400">•</span>
                <Link to="/louisiana" className="text-sm text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap">Louisiana</Link>
              </div>
            </div>

            {/* Fittings & Connections */}
            <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-xl border border-gray-200 hover:shadow-xl transition-all duration-300">
              <div className="flex items-center mb-4">
                <i className="ri-git-branch-line text-3xl text-teal-600 mr-3"></i>
                <h3 className="text-2xl font-bold text-gray-900">Fittings & Connections</h3>
              </div>
              <div className="space-y-2 mb-6">
                <p className="text-gray-700"><strong>Swagelok</strong> - Tube fittings, valves</p>
                <p className="text-gray-700"><strong>Parker</strong> - Hydraulic fittings</p>
                <p className="text-gray-700"><strong>Anderson Greenwood</strong> - Manifolds</p>
                <p className="text-gray-700"><strong>Hoke</strong> - Instrument valves</p>
              </div>
              <div className="flex flex-wrap gap-2 mb-4">
                <Link to="/texas" className="text-sm text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap">Texas</Link>
                <span className="text-gray-400">•</span>
                <Link to="/oklahoma" className="text-sm text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap">Oklahoma</Link>
                <span className="text-gray-400">•</span>
                <Link to="/louisiana" className="text-sm text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap">Louisiana</Link>
              </div>
            </div>

            {/* Industrial Valves */}
            <div className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-xl border border-gray-200 hover:shadow-xl transition-all duration-300">
              <div className="flex items-center mb-4">
                <i className="ri-tools-line text-3xl text-teal-600 mr-3"></i>
                <h3 className="text-2xl font-bold text-gray-900">Industrial Valves</h3>
              </div>
              <div className="space-y-2 mb-6">
                <p className="text-gray-700"><strong>Ball Valves</strong> - Q-Check, Dafram, CF Fluid Controls</p>
                <p className="text-gray-700"><strong>Butterfly Valves</strong> - Dafram, CF Fluid Controls</p>
                <p className="text-gray-700"><strong>Gate Valves</strong> - Warren, Chemvalve</p>
                <p className="text-gray-700"><strong>Check Valves</strong> - Flocheck, Q-Check</p>
                <p className="text-gray-700"><strong>Lined Plug Valves</strong> - Chemvalve, Q-Check</p>
              </div>
              <div className="flex flex-wrap gap-2 mb-4">
                <Link to="/texas" className="text-sm text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap">Texas</Link>
                <span className="text-gray-400">•</span>
                <Link to="/oklahoma" className="text-sm text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap">Oklahoma</Link>
                <span className="text-gray-400">•</span>
                <Link to="/louisiana" className="text-sm text-teal-600 hover:text-teal-700 font-medium whitespace-nowrap">Louisiana</Link>
              </div>
            </div>
          </div>

          {/* Additional Materials Section */}
          <div className="bg-gradient-to-r from-teal-600 to-teal-700 rounded-2xl p-12 text-white">
            <div className="max-w-4xl mx-auto">
              <h3 className="text-3xl font-bold mb-6 text-center">We Also Purchase</h3>
              <div className="grid md:grid-cols-3 gap-8 mb-8">
                <div>
                  <div className="mb-4">
                    <img 
                      src="https://readdy.ai/api/search-image?query=WIKA%20pressure%20gauges%20and%20thermowells%20with%20temperature%20sensors%2C%20precision%20industrial%20measurement%20instruments%20with%20brass%20and%20stainless%20steel%20construction%2C%20professional%20gauge%20equipment%20photography%20on%20clean%20background%20showing%20calibration%20dials%20and%20quality%20craftsmanship&width=600&height=600&seq=home-gauges-007&orientation=squarish"
                      alt="We Buy Surplus WIKA Gauges and Industrial Thermowells - Temperature and Pressure Measurement Equipment"
                      className="w-full h-40 object-cover rounded-lg"
                      loading="lazy"
                    />
                  </div>
                  <h4 className="text-xl font-bold mb-2">Temperature & Gauges</h4>
                  <p className="text-teal-100">WIKA gauges, thermowells, RTDs, all temp sensors, OCI, MCDaniel</p>
                </div>
                <div>
                  <div className="mb-4">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Industrial%20scrap%20metal%20materials%20including%20copper%20pipes%20brass%20fittings%20stainless%20steel%20components%20and%20alloy%20pieces%2C%20sorted%20recyclable%20metal%20materials%20in%20industrial%20setting%2C%20professional%20materials%20photography%20showing%20metallic%20textures%20and%20quality&width=600&height=600&seq=home-scrap-metal-008&orientation=squarish"
                      alt="We Buy Industrial Scrap Metal - Copper Brass Stainless Steel and Alloy Materials"
                      className="w-full h-40 object-cover rounded-lg"
                      loading="lazy"
                    />
                  </div>
                  <h4 className="text-xl font-bold mb-2">Scrap Metals</h4>
                  <p className="text-teal-100">Copper, brass, alloy, stainless steel, pipe fittings and flanges</p>
                </div>
                <div>
                  <div className="mb-4">
                    <img 
                      src="https://readdy.ai/api/search-image?query=Surplus%20industrial%20electric%20motors%20and%20electrical%20equipment%2C%20various%20motor%20types%20and%20sizes%20with%20wire%20spools%2C%20professional%20electrical%20surplus%20equipment%20photography%20on%20clean%20background%20showing%20quality%20industrial%20components&width=600&height=600&seq=home-electrical-009&orientation=squarish"
                      alt="We Buy Surplus Industrial Electric Motors and Electrical Equipment - All Types"
                      className="w-full h-40 object-cover rounded-lg"
                      loading="lazy"
                    />
                  </div>
                  <h4 className="text-xl font-bold mb-2">Electrical Surplus</h4>
                  <p className="text-teal-100">Motors all types, wire all types, electrical components</p>
                </div>
              </div>
              <div className="text-center">
                <a 
                  href="/contact" 
                  className="inline-block bg-white text-teal-600 px-8 py-4 rounded-lg font-bold text-lg hover:bg-gray-100 transition-colors whitespace-nowrap"
                >
                  Request a Quote Today
                </a>
              </div>
            </div>
          </div>

          {/* We Buy Surplus Valves Section */}
          <section className="py-20 bg-gray-50">
            <div className="container mx-auto px-4">
              <div className="text-center mb-16">
                <h2 className="text-4xl font-bold text-gray-900 mb-6">
                  We Buy Surplus Valves
                </h2>
                <p className="text-xl text-gray-600 max-w-4xl mx-auto mb-8">
                  America's leading buyer of surplus industrial valves from refineries, petrochemical plants, and manufacturing facilities. We purchase complete valve inventories, partial lots, and individual high-value units across all major brands and specifications.
                </p>
              </div>

              {/* Valve Categories */}
              <div className="grid md:grid-cols-3 gap-8 mb-16">
                <div className="bg-white rounded-lg p-8 shadow-lg">
                  <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <i className="ri-settings-4-line text-2xl text-red-600"></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center">Control Valves</h3>
                  <ul className="text-gray-600 space-y-2">
                    <li>• Fisher Control Valves</li>
                    <li>• Masoneilan Valves</li>
                    <li>• Dresser-Rand Valves</li>
                    <li>• Koso Valves</li>
                    <li>• Samson Valves</li>
                    <li>• Daniel Valves</li>
                  </ul>
                  <div className="mt-6 p-4 bg-gray-50 rounded-lg">
                    <img 
                      src="https://readdy.ai/api/search-image?query=industrial%20control%20valves%20surplus%20equipment%20warehouse%20shelves%20fisher%20emerson%20valve%20inventory%20organized%20storage%20facility&width=400&height=250&seq=cv001&orientation=landscape" 
                      alt="We Buy Surplus Control Valves Inventory" 
                      className="w-full h-32 object-cover object-top rounded"
                    />
                  </div>
                </div>

                <div className="bg-white rounded-lg p-8 shadow-lg">
                  <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <i className="ri-equalizer-line text-2xl text-green-600"></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center">Safety & Relief Valves</h3>
                  <ul className="text-gray-600 space-y-2">
                    <li>• Crosby Relief Valves</li>
                    <li>• Anderson Greenwood</li>
                    <li>• Consolidated Valves</li>
                    <li>• Kunkle Valves</li>
                    <li>• Leser Safety Valves</li>
                    <li>• Farris Valves</li>
                  </ul>
                  <div className="mt-6 p-4 bg-gray-50 rounded-lg">
                    <img 
                      src="https://readdy.ai/api/search-image?query=surplus%20safety%20relief%20valves%20crosby%20anderson%20greenwood%20industrial%20valve%20warehouse%20organized%20inventory%20stainless%20steel%20pressure%20relief%20valves&width=400&height=250&seq=srv001&orientation=landscape" 
                      alt="We Buy Surplus Safety Relief Valves" 
                      className="w-full h-32 object-cover object-top rounded"
                    />
                  </div>
                </div>

                <div className="bg-white rounded-lg p-8 shadow-lg">
                  <div className="w-16 h-16 bg-indigo-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <i className="ri-flow-chart text-2xl text-indigo-600"></i>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-4 text-center">Ball & Gate Valves</h3>
                  <ul className="text-gray-600 space-y-2">
                    <li>• Cameron Ball Valves</li>
                    <li>• Velan Gate Valves</li>
                    <li>• Bonney Forge Valves</li>
                    <li>• WKM Ball Valves</li>
                    <li>• Powell Valves</li>
                    <li>• Bray Controls</li>
                  </ul>
                  <div className="mt-6 p-4 bg-gray-50 rounded-lg">
                    <img 
                      src="https://readdy.ai/api/search-image?query=surplus%20ball%20gate%20valves%20cameron%20velan%20industrial%20valve%20warehouse%20organized%20rows%20high%20pressure%20valves%20refinery%20equipment%20storage&width=400&height=250&seq=bgv001&orientation=landscape" 
                      alt="We Buy Surplus Ball and Gate Valves" 
                      className="w-full h-32 object-cover object-top rounded"
                    />
                  </div>
                </div>
              </div>

              {/* States We Serve */}
              <div className="bg-white rounded-xl p-8 shadow-lg mb-16">
                <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Surplus Valve Buyers by State</h3>
                <div className="grid md:grid-cols-3 lg:grid-cols-3 gap-6">
                  <a 
                    href="/texas" 
                    className="group bg-red-50 hover:bg-red-100 rounded-lg p-6 transition-all duration-300 border border-red-200 hover:border-red-300 cursor-pointer"
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h4 className="text-lg font-semibold text-gray-900 group-hover:text-red-700">Texas</h4>
                      <i className="ri-arrow-right-line text-red-600 group-hover:translate-x-1 transition-transform"></i>
                    </div>
                    <p className="text-gray-600 mb-3 text-sm">Gulf Coast refineries, petrochemical plants, Houston Ship Channel facilities</p>
                    <div className="text-xs text-red-600 font-semibold">8,500+ valves purchased • 24hr response</div>
                  </a>

                  <a 
                    href="/oklahoma" 
                    className="group bg-red-50 hover:bg-red-100 rounded-lg p-6 transition-all duration-300 border border-red-200 hover:border-red-300 cursor-pointer"
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h4 className="text-lg font-semibold text-gray-900 group-hover:text-red-700">Oklahoma</h4>
                      <i className="ri-arrow-right-line text-red-600 group-hover:translate-x-1 transition-transform"></i>
                    </div>
                    <p className="text-gray-600 mb-3 text-sm">Tulsa oil capital, Cushing hub, Devon Energy corridor facilities</p>
                    <div className="text-xs text-red-600 font-semibold">2,100+ valves purchased • 48hr response</div>
                  </a>

                  <a 
                    href="/louisiana" 
                    className="group bg-red-50 hover:bg-red-100 rounded-lg p-6 transition-all duration-300 border border-red-200 hover:border-red-300 cursor-pointer"
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h4 className="text-lg font-semibold text-gray-900 group-hover:text-red-700">Louisiana</h4>
                      <i className="ri-arrow-right-line text-red-600 group-hover:translate-x-1 transition-transform"></i>
                    </div>
                    <p className="text-gray-600 mb-3 text-sm">Baton Rouge corridor, Lake Charles complex, Mississippi River facilities</p>
                    <div className="text-xs text-red-600 font-semibold">3,200+ valves purchased • 36hr response</div>
                  </a>

                  <a 
                    href="/new-mexico" 
                    className="group bg-red-50 hover:bg-red-100 rounded-lg p-6 transition-all duration-300 border border-red-200 hover:border-red-300 cursor-pointer"
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h4 className="text-lg font-semibold text-gray-900 group-hover:text-red-700">New Mexico</h4>
                      <i className="ri-arrow-right-line text-red-600 group-hover:translate-x-1 transition-transform"></i>
                    </div>
                    <p className="text-gray-600 mb-3 text-sm">Permian Basin operations, Artesia refinery, Hobbs production facilities</p>
                    <div className="text-xs text-red-600 font-semibold">800+ valves purchased • 48hr response</div>
                  </a>

                  <a 
                    href="/north-dakota" 
                    className="group bg-red-50 hover:bg-red-100 rounded-lg p-6 transition-all duration-300 border border-red-200 hover:border-red-300 cursor-pointer"
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h4 className="text-lg font-semibold text-gray-900 group-hover:text-red-700">North Dakota</h4>
                      <i className="ri-arrow-right-line text-red-600 group-hover:translate-x-1 transition-transform"></i>
                    </div>
                    <p className="text-gray-600 mb-3 text-sm">Bakken shale operations, Williston basin, Bismarck manufacturing</p>
                    <div className="text-xs text-red-600 font-semibold">600+ valves purchased • 72hr response</div>
                  </a>

                  <a 
                    href="/south-dakota" 
                    className="group bg-red-50 hover:bg-red-100 rounded-lg p-6 transition-all duration-300 border border-red-200 hover:border-red-300 cursor-pointer"
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h4 className="text-lg font-semibold text-gray-900 group-hover:text-red-700">South Dakota</h4>
                      <i className="ri-arrow-right-line text-red-600 group-hover:translate-x-1 transition-transform"></i>
                    </div>
                    <p className="text-gray-600 mb-3 text-sm">Sioux Falls industrial, Rapid City processing, agricultural facilities</p>
                    <div className="text-xs text-red-600 font-semibold">400+ valves purchased • 72hr response</div>
                  </a>

                  <a 
                    href="/kansas" 
                    className="group bg-red-50 hover:bg-red-100 rounded-lg p-6 transition-all duration-300 border border-red-200 hover:border-red-300 cursor-pointer"
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h4 className="text-lg font-semibold text-gray-900 group-hover:text-red-700">Kansas</h4>
                      <i className="ri-arrow-right-line text-red-600 group-hover:translate-x-1 transition-transform"></i>
                    </div>
                    <p className="text-gray-600 mb-3 text-sm">Wichita manufacturing, Kansas City processing, Topeka industrial</p>
                    <div className="text-xs text-red-600 font-semibold">700+ valves purchased • 48hr response</div>
                  </a>

                  <a 
                    href="/utah" 
                    className="group bg-red-50 hover:bg-red-100 rounded-lg p-6 transition-all duration-300 border border-red-200 hover:border-red-300 cursor-pointer"
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h4 className="text-lg font-semibold text-gray-900 group-hover:text-red-700">Utah</h4>
                      <i className="ri-arrow-right-line text-red-600 group-hover:translate-x-1 transition-transform"></i>
                    </div>
                    <p className="text-gray-600 mb-3 text-sm">Salt Lake City refinery, Provo manufacturing, mining operations</p>
                    <div className="text-xs text-red-600 font-semibold">500+ valves purchased • 48hr response</div>
                  </a>

                  <a 
                    href="/wyoming" 
                    className="group bg-red-50 hover:bg-red-100 rounded-lg p-6 transition-all duration-300 border border-red-200 hover:border-red-300 cursor-pointer"
                  >
                    <div className="flex items-center justify-between mb-4">
                      <h4 className="text-lg font-semibold text-gray-900 group-hover:text-red-700">Wyoming</h4>
                      <i className="ri-arrow-right-line text-red-600 group-hover:translate-x-1 transition-transform"></i>
                    </div>
                    <p className="text-gray-600 mb-3 text-sm">Casper refinery, Cheyenne facilities, Powder River basin operations</p>
                    <div className="text-xs text-red-600 font-semibold">350+ valves purchased • 72hr response</div>
                  </a>
                </div>

                <div className="mt-12 text-center">
                  <div className="bg-gray-50 rounded-lg p-8 max-w-4xl mx-auto">
                    <h4 className="text-xl font-semibold text-gray-900 mb-4">Why Choose Us for Your Surplus Valves?</h4>
                    <div className="grid md:grid-cols-2 gap-6 text-left">
                      <div>
                        <div className="flex items-center mb-2">
                          <i className="ri-money-dollar-circle-line text-green-600 mr-2"></i>
                          <span className="font-semibold">Competitive Pricing</span>
                        </div>
                        <p className="text-gray-600 text-sm">Fair market value based on current demand and condition</p>
                      </div>
                      <div>
                        <div className="flex items-center mb-2">
                          <i className="ri-truck-line text-green-600 mr-2"></i>
                          <span className="font-semibold">Free Pickup Service</span>
                        </div>
                        <p className="text-gray-600 text-sm">We handle all logistics and transportation at no cost</p>
                      </div>
                      <div>
                        <div className="flex items-center mb-2">
                          <i className="ri-time-line text-green-600 mr-2"></i>
                          <span className="font-semibold">Quick Response</span>
                        </div>
                        <p className="text-gray-600 text-sm">Fast quotes and immediate payment upon agreement</p>
                      </div>
                      <div>
                        <div className="flex items-center mb-2">
                          <i className="ri-shield-check-line text-green-600 mr-2"></i>
                          <span className="font-semibold">Proper Documentation</span>
                        </div>
                        <p className="text-gray-600 text-sm">Complete paperwork and certificates for compliance</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Surplus Valve Buyers in Cities */}
              <div className="bg-gradient-to-br from-teal-50 to-white rounded-xl p-8 shadow-lg border border-teal-100">
                <h3 className="text-2xl font-bold text-gray-900 mb-8 text-center">Surplus Valve Buyers in:</h3>
                <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                  <Link to="/houston" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Houston</h4>
                    <p className="text-sm text-gray-600">Leading buyer of surplus industrial valves in Houston's petrochemical corridor and Ship Channel facilities.</p>
                  </Link>

                  <Link to="/dallas" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Dallas</h4>
                    <p className="text-sm text-gray-600">Professional surplus valve purchasing services for Dallas-Fort Worth industrial and manufacturing facilities.</p>
                  </Link>

                  <Link to="/austin" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Austin</h4>
                    <p className="text-sm text-gray-600">Competitive pricing for surplus valves from Austin's technology manufacturing and industrial operations.</p>
                  </Link>

                  <Link to="/san-antonio" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in San Antonio</h4>
                    <p className="text-sm text-gray-600">Fast response for surplus valve purchases from San Antonio refineries and Eagle Ford operations.</p>
                  </Link>

                  <Link to="/corpus-christi" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Corpus Christi</h4>
                    <p className="text-sm text-gray-600">Specialized in purchasing surplus valves from Corpus Christi's coastal refining and petrochemical plants.</p>
                  </Link>

                  <Link to="/el-paso" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in El Paso</h4>
                    <p className="text-sm text-gray-600">Reliable surplus valve buyer serving El Paso's border manufacturing and Permian Basin operations.</p>
                  </Link>

                  <Link to="/beaumont" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Beaumont</h4>
                    <p className="text-sm text-gray-600">Expert valve purchasing for Beaumont's Golden Triangle refineries and chemical processing facilities.</p>
                  </Link>

                  <Link to="/oklahoma-city" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Oklahoma City</h4>
                    <p className="text-sm text-gray-600">Top dollar for surplus valves from Oklahoma City's energy sector and industrial manufacturing plants.</p>
                  </Link>

                  <Link to="/tulsa" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Tulsa</h4>
                    <p className="text-sm text-gray-600">Immediate quotes for surplus valves from Tulsa's oil capital refineries and pipeline operations.</p>
                  </Link>

                  <Link to="/baton-rouge" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Baton Rouge</h4>
                    <p className="text-sm text-gray-600">Premium pricing for surplus valves from Baton Rouge's massive petrochemical corridor facilities.</p>
                  </Link>

                  <Link to="/lake-charles" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Lake Charles</h4>
                    <p className="text-sm text-gray-600">Fast turnaround for surplus valve purchases from Lake Charles refinery and LNG terminal operations.</p>
                  </Link>

                  <Link to="/albuquerque" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Albuquerque</h4>
                    <p className="text-sm text-gray-600">Professional valve purchasing services for Albuquerque's industrial and manufacturing facilities.</p>
                  </Link>

                  <Link to="/roswell" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Roswell</h4>
                    <p className="text-sm text-gray-600">Competitive rates for surplus valves from Roswell's Permian Basin oil and gas operations.</p>
                  </Link>

                  <Link to="/hobbs" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Hobbs</h4>
                    <p className="text-sm text-gray-600">Specialized buyer for surplus valves from Hobbs' Permian Basin production and processing facilities.</p>
                  </Link>

                  <Link to="/wichita" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Wichita</h4>
                    <p className="text-sm text-gray-600">Reliable surplus valve buyer for Wichita's aerospace manufacturing and industrial facilities.</p>
                  </Link>

                  <Link to="/kansas-city" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Kansas City</h4>
                    <p className="text-sm text-gray-600">Fast quotes for surplus valves from Kansas City's metro industrial and processing operations.</p>
                  </Link>

                  <Link to="/sioux-falls" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Sioux Falls</h4>
                    <p className="text-sm text-gray-600">Competitive buyer for surplus valves from Sioux Falls' ethanol production and food processing plants.</p>
                  </Link>

                  <Link to="/rapid-city" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Rapid City</h4>
                    <p className="text-sm text-gray-600">Expert valve purchasing for Rapid City's Black Hills mining operations and industrial facilities.</p>
                  </Link>

                  <Link to="/cheyenne" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Cheyenne</h4>
                    <p className="text-sm text-gray-600">Fast response for surplus valve purchases from Cheyenne's capital region industrial operations.</p>
                  </Link>

                  <Link to="/casper" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Casper</h4>
                    <p className="text-sm text-gray-600">Premium pricing for surplus valves from Casper's refinery and Powder River Basin operations.</p>
                  </Link>

                  <Link to="/salt-lake-city" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Salt Lake City</h4>
                    <p className="text-sm text-gray-600">Professional valve purchasing for Salt Lake City's refinery and mining industry operations.</p>
                  </Link>

                  <Link to="/provo" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Provo</h4>
                    <p className="text-sm text-gray-600">Reliable buyer for surplus valves from Provo's manufacturing and industrial processing facilities.</p>
                  </Link>

                  <Link to="/denver" className="group bg-white hover:bg-teal-50 rounded-lg p-5 transition-all duration-300 border border-gray-200 hover:border-teal-300">
                    <h4 className="text-base font-semibold text-teal-700 mb-2 group-hover:text-teal-800">Surplus Valve Buyers in Denver</h4>
                    <p className="text-sm text-gray-600">Top dollar for surplus valves from Denver's Front Range industrial and energy sector facilities.</p>
                  </Link>
                </div>

                <div className="mt-8 text-center">
                  <p className="text-gray-600 mb-4">
                    We provide professional surplus valve purchasing services across all major industrial cities in our 9-state service area.
                  </p>
                  <a 
                    href="tel:214-854-5638" 
                    className="inline-block bg-teal-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-teal-700 transition-colors whitespace-nowrap"
                  >
                    Call (214) 854-5638 for Immediate Quote
                  </a>
                </div>
              </div>
            </div>
          </section>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Home;